import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  .split-button-left {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding: 8px 16px;
  }

  .split-button-right {
    display: flex;
    min-height: 32px;
    padding: 5px 8px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;
